import { Typography } from '@mui/material'
import React from 'react'
import { Box } from '@mui/system'
import LinkBtn from '../../components/Buttons/LinkBtn'
import AppRoutes from '../../services/AppRoutes'
import received from '../../images/Received.svg'
import UseTranslation from '../../hooks/UseTranslation'

const EmailSent = () => {
  const { t } = UseTranslation()
  return (
    <>
      <Box sx={styles.boxContainer}>
        <Box component={'img'} sx={styles.mailImage} src={received} />
        <Box sx={styles.boxText}>
          <Typography sx={styles.boxTitle}>
            {t?.['Password reset instructions sent to your mail !']}
          </Typography>
          <Typography sx={styles.boxSubTitle}>
            {t?.['Please follow these instructions to reset your password and login to our system again..']}
          </Typography>
        </Box>
      </Box>
      <Box sx={styles.forgotPasswordContainer}>
        <LinkBtn customStyle={styles.forgotPassword} to={AppRoutes.login} name={t?.Finish} />
      </Box>
    </>
  )
}
const styles = {
  boxContainer: {
    boxSizing: 'border-box',
    padding: { xs: '5px 15px', sm: '10px 15px' },
    maxWidth: { xs: '100%', md: '620px' },
    width: '100%',
    height: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '5px',
    border: '1px solid #29cc8b',
    backgroundColor: '#f7fcf9',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
    marginBottom: '20px',
    gap: '20px',
  },
  mailImage: {
    width: { xs: '40px', sm: '50px' },
    height: { xs: '40px', sm: '50px' },
  },
  boxText: {
    display: 'flex',
    flexDirection: 'column',
  },
  boxTitle: {
    fontSize: { xs: '14px', sm: '18px' },
    fontWeight: 800,
    my: '5px',
  },
  boxSubTitle: {
    fontSize: { xs: '12px', sm: '16px' },
    color: '#92929D',
  },
  forgotPasswordContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  forgotPassword: {
    boxSizing: 'border-box',
    fontSize: { xs: '14px', sm: '16px' },
    width: { xs: '100%', sm: '150px' },
    minWidth: { xs: '100%', sm: '180px' },
    marginTop: '10px',
  },
}
export default EmailSent
